import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { IconButton } from '@material-ui/core';

import VentanaPrincipal from './VentanaPrincipalRR';
import RegistroOficio from './RegistroOficio';
import { Link } from 'react-router-dom';
import {Modal,Button} from 'react-bootstrap'
import CardUserPhoto from './CardUserPhoto';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigationIcon from '@material-ui/icons/Navigation';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ReactBigCalendar from './ReactBigCalendar';


const styles = theme => ({
    card: {
        flexGrow: 1,
    },
    mainContainer: {
        flex: 1,
        
    }
});


class CardUserData2 extends Component {
    constructor(props){
        super(props);

        console.log("Los PUTOS PROPS")
        console.log(props)
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        
        this.state = {
           
            show: false,
            oficiosR: ''
          };

         

    }

    componentDidMount(){
       
          this.setState({ oficiosR: this.props.oficiosR})
          console.log("cargand props")
          console.log(this.props)
        
    }

    handleClose() {
        this.setState({ show: false });
      }
    
      handleShow() {
        this.setState({ show: true });
        console.log("OficiosR")
        console.log(this.state.oficiosR)
      }

      areglar(oficios){
        this.setState({ oficiosR: oficios})
      }
    render(){
        const {classes, 
               tableHeader,
               tableData,
               oficiosR,
               oficiosEP,
               titulo,
               handleButtonsEvents,
               handleRemove,
               stopEditing,
               handleChange,
               buttons,
               onClick,
               usuario,
               iduser,
               indice,
               etiqueta,
               startEditing,
               editIdx} = this.props;

              // this.areglar(oficiosR)

              const fg= this.props.oficiosR

              let buttonR;
              {/*
              if(this.props.usuario==453|| this.props.usuario==undefined){
buttonR=<><Button  onClick={this.handleShow} className="btn btn-success">
REGISTRAR <AddIcon className={classes.extendedIcon} /></Button><p></p></>
              }
            */ }
        return(
        <div className={classes.mainContainer}>
            <Card className={classes.card}>
               
               
                <CardContent>
                <h3 align="center"></h3>
                
            
               <h2 align="center">Citas</h2>
                
               
     
     
                <td>
                <>
            
      
                <Modal 
               size="xl"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
              show={this.state.show} onHide={this.handleClose} centered>
                <Modal.Header closeButton>
                <Modal.Title>Registro de Oficio </Modal.Title>
                </Modal.Header>
                <Modal.Body>
               
               
                <RegistroOficio id_usuario={usuario}/>
      
              
                </Modal.Body>
                
              </Modal>
            </>
                </td>
                <br/>
                <ReactBigCalendar citas={oficiosR}/>
                     {/*<VentanaPrincipal oficiosR={oficiosEP}
                      titulo={fg}
                      indice={indice}
                      id_usuario={usuario}
                      iduser={iduser}
                     
                      etiqueta={etiqueta}
                      buttons={buttons}
                      onClick={onClick}
                      etiquetaA={this.props.etiquetaA}

                      
        />*/}
                </CardContent>
            </Card>
        </div>
        );
    }
}

CardUserData2.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeader: PropTypes.object.isRequired,
    tableData: PropTypes.object.isRequired,
    oficiosR: PropTypes.object.isRequired,
    handleButtonsEvents: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
    stopEditing: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    editIdx: PropTypes.number.isRequired,
    startEditing: PropTypes.func.isRequired
};

export default withStyles(styles)(CardUserData2);